import {
  differenceInDays,
  differenceInMonths,
  differenceInWeeks,
  differenceInYears,
  subDays,
  subMonths,
  subWeeks,
  subYears,
} from "date-fns";
import type { SnapshotEventReminderFrequency } from "@/modules/snapshots/businessReports.types";

type UnitSubtractFn = (date: Date, amount: number) => Date;
type UnitDiffFn = (later: Date, earlier: Date) => number;

const UNIT_TO_SUBTRACT: Record<SnapshotEventReminderFrequency, UnitSubtractFn> = {
  DAILY: subDays,
  WEEKLY: subWeeks,
  MONTHLY: subMonths,
  YEARLY: subYears,
};

const UNIT_TO_DIFF: Record<SnapshotEventReminderFrequency, UnitDiffFn> = {
  DAILY: differenceInDays,
  WEEKLY: differenceInWeeks,
  MONTHLY: differenceInMonths,
  YEARLY: differenceInYears,
};

export const computeReminderStartDate = (anchor: Date, value: number, unit: SnapshotEventReminderFrequency): Date =>
  UNIT_TO_SUBTRACT[unit](anchor, value);

export const computeReminderOffset = (anchor: Date, start: Date, unit: SnapshotEventReminderFrequency): number =>
  UNIT_TO_DIFF[unit](anchor, start);
